import * as React from 'react'
import g from 'glamorous'

import Navbar from '../components/Navbar'
import CreateUserForm from './createUser/CreateUserForm'
import Headline from '../components/Headline'
import CreateUserMutation from '../components/mutations/CreateUserMutation'
import usersQuery from '../graphql/queries/users'
import history from '../history'

export interface CreateUserProps {}

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  }
})

const CreateUser: React.SFC<CreateUserProps> = () => {
  return (
    <div>
      <Navbar />
      <StyledContainer>
        <Headline>Vytvořit uživatele</Headline>
        <CreateUserMutation>
          {(createUser, { data, error }) => (
            <CreateUserForm
              formError={error}
              onSubmit={async ({ email, name, admin, isPassive }) => {
                await createUser({
                  variables: { admin, email: isPassive ? null : email, name },
                  refetchQueries: [{
                    query: usersQuery
                  }]
                })

                history.push('/users')
              }}
            />
          )}
        </CreateUserMutation>
      </StyledContainer>
    </div>
  )
}

export default CreateUser



// WEBPACK FOOTER //
// ./src/screens/CreateUser.tsx